// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs__container{
    display: flex;
}
.tabs__container__row{
    flex-direction: row;
}

.tabs__container__colmn{
    flex-direction: column;
    width: inherit;
}

.tabs__container__colmn .next-arrow svg{
    transform: rotate(90deg);
}

.tabs__container__colmn .previous-arrow svg{
    transform: rotate(90deg);
}

.tabs__container__row  .row-slider{
    width: 100%;
}

.row-slider{
    overflow: hidden;
}

#tabs{
    --tab-background: #828282;
    --tab-background-active: rgba(0, 0, 0, 0.8);
    --tab-font-family: Tahoma;
    --tab-font-size: 12px;
    --tab-text-align: left;
    --tab-font-style: normal;
    --tab-font-weight: normal;
    --tab-text-decoration: none;
    --tab-color: white;
    --tab-height: 29px;
    --tab-width: "fit-content";
    --tabs-flex-wrap: "nowrap"
}
.tab__presentation {
    display: flex;
    flex-wrap: wrap;
    margin-top: 15px;
}
.tabpanel {
    width: 816px;
    height: auto;
    display: flex;
    margin-bottom: 15px;
    flex-shrink: 0;
}
.tab_column {
    flex-direction: column;
}
.tab_row {
    flex-direction: row;
}
.row_reverse {
    flex-direction: row-reverse;
}
.column_reverse {
    flex-direction: column-reverse;
}
.tabpanel__body {
    background: #FFFFFF;
    border: 1px solid #8DA1C0;
    box-sizing: border-box;
    flex: 1;
    min-height: 100px;
    height: auto;
}
.tabpanel__header {
    background: #E8ECF2;
    display: flex;
}
.tabs__container__colmn .control_btn {
    width: 100%;
    height: 30px;
}
.tabs__container__row .control_btn {
    height: 100%;
    width: 30px;
}
.control_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #696968;
    cursor: default;
}
.control_btn.active {
    background: #000;
    cursor: pointer;
}
.control_btn.active:hover {
    background: #333331;
}
.tabheader__row {
    display: flex;
    flex-wrap: var(--tabs-flex-wrap);
    width: 100%;
}
.tabheader__row button {
    margin-left: 1px;
    margin-bottom: 1px;
}
.tabheader__column {
    flex-direction: column;
    width: auto;
    max-width: 100%;
    height: 100%;
    flex-wrap: var(--tabs-flex-wrap);
}
.tabheader__column .tabpanel__btn_black {
    margin-bottom: 1px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
}
.tabpanel__btn_black {
    position: relative;
    min-width: 28px;
    width: var(--tab-width);
    height: var(--tab-height);
    padding: 0 1em;
    flex-shrink: 0;
    background: var(--tab-background);
    font-family: var(--tab-font-family);
    font-size: var(--tab-font-size);
    text-align: var(--tab-text-align);
    font-style: var(--tab-font-style);
    font-weight: var(--tab-font-weight);
    text-decoration: var(--tab-text-decoration);
    color: var(--tab-color);
    transition: .3s;
    cursor: pointer;
    outline: none;
    border: none;
}
.tabpanel__btn_black.active {
    background: var(--tab-background-active);
}
.vertical-tabs > button.tabpanel__btn_black.active {
    flex-shrink: 0;
}
.tabpanel__btn_black:hover {
    background: var(--tab-background-active);
}
.tabpanel__btn.active {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), #2C6FD7;
}
.tabpanel__btn:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), #2C6FD7;
}
.rotated > button {
    height: 100px;
    width: 29px;
    overflow: hidden;
}
.rotated > button span {
    display: inline-block;
    width: 100px;
    height: 100px;
    transform:rotate(-90deg)
}`, "",{"version":3,"sources":["webpack://./src/controls/paneltabcontrol/paneltabcontrol.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,2CAA2C;IAC3C,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B;AACJ;AACA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,8BAA8B;AAClC;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,OAAO;IACP,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,gCAAgC;IAChC,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,cAAc;IACd,iCAAiC;IACjC,mCAAmC;IACnC,+BAA+B;IAC/B,iCAAiC;IACjC,iCAAiC;IACjC,mCAAmC;IACnC,2CAA2C;IAC3C,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,aAAa;IACb,YAAY;AAChB;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,cAAc;AAClB;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,kFAAkF;AACtF;AACA;IACI,kFAAkF;AACtF;AACA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb;AACJ","sourcesContent":[".tabs__container{\r\n    display: flex;\r\n}\r\n.tabs__container__row{\r\n    flex-direction: row;\r\n}\r\n\r\n.tabs__container__colmn{\r\n    flex-direction: column;\r\n    width: inherit;\r\n}\r\n\r\n.tabs__container__colmn .next-arrow svg{\r\n    transform: rotate(90deg);\r\n}\r\n\r\n.tabs__container__colmn .previous-arrow svg{\r\n    transform: rotate(90deg);\r\n}\r\n\r\n.tabs__container__row  .row-slider{\r\n    width: 100%;\r\n}\r\n\r\n.row-slider{\r\n    overflow: hidden;\r\n}\r\n\r\n#tabs{\r\n    --tab-background: #828282;\r\n    --tab-background-active: rgba(0, 0, 0, 0.8);\r\n    --tab-font-family: Tahoma;\r\n    --tab-font-size: 12px;\r\n    --tab-text-align: left;\r\n    --tab-font-style: normal;\r\n    --tab-font-weight: normal;\r\n    --tab-text-decoration: none;\r\n    --tab-color: white;\r\n    --tab-height: 29px;\r\n    --tab-width: \"fit-content\";\r\n    --tabs-flex-wrap: \"nowrap\"\r\n}\r\n.tab__presentation {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin-top: 15px;\r\n}\r\n.tabpanel {\r\n    width: 816px;\r\n    height: auto;\r\n    display: flex;\r\n    margin-bottom: 15px;\r\n    flex-shrink: 0;\r\n}\r\n.tab_column {\r\n    flex-direction: column;\r\n}\r\n.tab_row {\r\n    flex-direction: row;\r\n}\r\n.row_reverse {\r\n    flex-direction: row-reverse;\r\n}\r\n.column_reverse {\r\n    flex-direction: column-reverse;\r\n}\r\n.tabpanel__body {\r\n    background: #FFFFFF;\r\n    border: 1px solid #8DA1C0;\r\n    box-sizing: border-box;\r\n    flex: 1;\r\n    min-height: 100px;\r\n    height: auto;\r\n}\r\n.tabpanel__header {\r\n    background: #E8ECF2;\r\n    display: flex;\r\n}\r\n.tabs__container__colmn .control_btn {\r\n    width: 100%;\r\n    height: 30px;\r\n}\r\n.tabs__container__row .control_btn {\r\n    height: 100%;\r\n    width: 30px;\r\n}\r\n.control_btn {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: #696968;\r\n    cursor: default;\r\n}\r\n.control_btn.active {\r\n    background: #000;\r\n    cursor: pointer;\r\n}\r\n.control_btn.active:hover {\r\n    background: #333331;\r\n}\r\n.tabheader__row {\r\n    display: flex;\r\n    flex-wrap: var(--tabs-flex-wrap);\r\n    width: 100%;\r\n}\r\n.tabheader__row button {\r\n    margin-left: 1px;\r\n    margin-bottom: 1px;\r\n}\r\n.tabheader__column {\r\n    flex-direction: column;\r\n    width: auto;\r\n    max-width: 100%;\r\n    height: 100%;\r\n    flex-wrap: var(--tabs-flex-wrap);\r\n}\r\n.tabheader__column .tabpanel__btn_black {\r\n    margin-bottom: 1px;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    max-width: 100%;\r\n}\r\n.tabpanel__btn_black {\r\n    position: relative;\r\n    min-width: 28px;\r\n    width: var(--tab-width);\r\n    height: var(--tab-height);\r\n    padding: 0 1em;\r\n    flex-shrink: 0;\r\n    background: var(--tab-background);\r\n    font-family: var(--tab-font-family);\r\n    font-size: var(--tab-font-size);\r\n    text-align: var(--tab-text-align);\r\n    font-style: var(--tab-font-style);\r\n    font-weight: var(--tab-font-weight);\r\n    text-decoration: var(--tab-text-decoration);\r\n    color: var(--tab-color);\r\n    transition: .3s;\r\n    cursor: pointer;\r\n    outline: none;\r\n    border: none;\r\n}\r\n.tabpanel__btn_black.active {\r\n    background: var(--tab-background-active);\r\n}\r\n.vertical-tabs > button.tabpanel__btn_black.active {\r\n    flex-shrink: 0;\r\n}\r\n.tabpanel__btn_black:hover {\r\n    background: var(--tab-background-active);\r\n}\r\n.tabpanel__btn.active {\r\n    background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), #2C6FD7;\r\n}\r\n.tabpanel__btn:hover {\r\n    background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), #2C6FD7;\r\n}\r\n.rotated > button {\r\n    height: 100px;\r\n    width: 29px;\r\n    overflow: hidden;\r\n}\r\n.rotated > button span {\r\n    display: inline-block;\r\n    width: 100px;\r\n    height: 100px;\r\n    transform:rotate(-90deg)\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
